/**
 * Maps API `AppointmentStatus` (api-medpharma's appointment-enums.ts) to
 * UI labels + a real color per status — same idiom as
 * e-prescriptions.ts's doctorPrescriptionStatusConfig. Every status
 * resolves to an actually-visible color rather than antd's `"default"`
 * (a bordered no-fill outline, not a real color).
 */
export const appointmentStatusConfig: Record<string, { color: string; label: string }> = {
  scheduled: { color: "#94a3b8", label: "Scheduled" },
  confirmed: { color: "processing", label: "Confirmed" },
  rescheduled: { color: "warning", label: "Rescheduled" },
  checked_in: { color: "cyan", label: "Checked in" },
  in_progress: { color: "processing", label: "In progress" },
  completed: { color: "success", label: "Completed" },
  canceled: { color: "error", label: "Cancelled" },
  no_show: { color: "#78716c", label: "No show" },
  Pending: { color: "#94a3b8", label: "Pending" },
};
